import type { ContainerConfig } from '../../components/container-types/types';

const isDrawerType = (containerConfig?: ContainerConfig) => {
  return containerConfig?.type === 'drawer';
};

export default isDrawerType;
